import { ShieldCheck } from "lucide-react";
import { money } from "@/lib/api";

const pct = (v) => (typeof v === "number" ? `${v}%` : null);

export const fddRows = (f) => {
  const i19 = f.item19 || {}, i20 = f.item20 || {};
  return [
    ["Initial franchise fee (Item 5)", f.initial_fee != null && money(f.initial_fee)], ["Royalty (Item 6)", pct(f.royalty_pct)], ["Marketing fund (Item 6)", pct(f.marketing_pct)],
    ["Total investment (Item 7)", (f.investment_low != null || f.investment_high != null) && `${money(f.investment_low)} – ${money(f.investment_high)}`],
    ["Average unit revenue (Item 19)", i19.avg_revenue != null && money(i19.avg_revenue)], ["Median unit revenue (Item 19)", i19.median_revenue != null && money(i19.median_revenue)],
    ["Units in the system (Item 20)", i20.total_units != null && String(i20.total_units)],
  ].filter(([, v]) => v);
};

export const FddVerified = ({ fdd }) => {
  if (!fdd) return null;
  const i19 = fdd.item19 || {}, i20 = fdd.item20 || {};
  return (
    <div className="mb-6 rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-5" data-testid="fdd-verified">
      <p className="flex items-center gap-2 text-sm font-semibold text-emerald-300 mb-1"><ShieldCheck className="h-4 w-4" />Verified from FDD</p>
      <p className="text-xs text-slate-400 mb-4">{fdd.filename}{fdd.fdd_year ? ` · ${fdd.fdd_year}` : ""}{fdd.reviewed ? " · reviewed by staff" : ""}</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {fddRows(fdd).map(([k, v]) => (
          <div key={k} className="rounded-md border border-slate-800 bg-slate-950/50 p-3"><p className="text-[10px] uppercase tracking-wider text-slate-500 mb-1">{k}</p><p className="num font-semibold">{v}</p></div>
        ))}
      </div>
      {(i19.summary || i19.provided === false) && <p className="text-sm text-slate-300 mb-2"><span className="font-semibold text-slate-200">Item 19: </span>{i19.summary || "No financial performance representation."}</p>}
      {i20.summary && <p className="text-sm text-slate-300"><span className="font-semibold text-slate-200">Item 20: </span>{i20.summary}</p>}
    </div>
  );
};
